import Routes from "./Routes";
import { productData } from "./productData.js";

const makeHeaders = (token) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Vary", "Accept, Origin");
  myHeaders.append("Allow", "GET, HEAD, OPTIONS");

  return myHeaders;
};

function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return {
    data: array,
  };
}

const getProducts = async (number = null, random = null) => {
  let array = productData;

  // if(random){
  //   array = shuffle(array);
  // }
  if (number) {
    array.slice(0, parseInt(number));
  }

  return {
    data: array,
  };
};

const getProductsByCategories = async (categories, number = 16) => {
  const array = categories.length
    ? productData.filter((p) =>
        categories.some((c) => p.categories.includes(c))
      )
    : productData;
  let newArray;
  let pagination = null;

  if (number) {
    newArray = array.slice(0, parseInt(number));
    pagination = array.slice[(parseInt(number), parseInt(number) * 2)]
      ? [parseInt(number), parseInt(number) * 2]
      : null;
  }

  return {
    data: newArray,
    next: pagination,
  };
};

const getPagination = async (url) => {
  const pagination = await fetch(`${Routes.main}${url}`)
    .then((data) => data.json())
    .catch((err) => {
      return false;
    });

  return pagination;
};

const getProduct = async (id) => {
  return productData.find((p) => p.id == id);
};

const getCategoryProducts = async (category) => {
  const productsCategory = await fetch(
    `${Routes.main}/api/productscategory/${category}/`
  ).then((data) => data.json());

  return productsCategory;
};

export {
  getProducts,
  getProduct,
  getCategoryProducts,
  getPagination,
  getProductsByCategories,
};
